import { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { Menu, X } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_healthy-future/artifacts/heje4o4g_saha-logo%20-%20Edited%20-%20Edited.png";

const Logo = () => (
  <a href="#top" data-testid="logo-link" className="flex items-center gap-3">
    <span className="relative inline-flex items-center justify-center w-11 h-11 rounded-2xl bg-[var(--text-primary)] overflow-hidden">
      <img
        src={LOGO_URL}
        alt="Saha Lab"
        className="w-9 h-9 object-contain"
        loading="eager"
      />
    </span>
    <div className="flex flex-col leading-none">
      <span className="font-display text-[15px] font-semibold tracking-tight text-[var(--text-primary)]">
        Saha Lab
      </span>
      <span className="text-[10px] tracking-wider text-[var(--brand-gold)] mt-0.5">
        صحة لاب
      </span>
    </div>
  </a>
);

const Header = () => {
  const { t, toggle } = useLanguage();
  const [mobileOpen, setMobileOpen] = useState(false);

  const navLinks = [
    { href: "#products", label: t.nav.products, id: "nav-products" },
    { href: "#mission", label: t.nav.mission, id: "nav-mission" },
    { href: "#contact", label: t.nav.contact, id: "nav-contact" },
  ];

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 bg-[var(--bg-base)]/85 backdrop-blur-xl border-b border-[var(--bg-subtle)]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Logo />

        <nav className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={link.href}
              data-testid={link.id}
              className="text-sm text-[var(--text-secondary)] hover:text-[var(--text-primary)]"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            type="button"
            data-testid="lang-toggle-btn"
            onClick={toggle}
            aria-label="Toggle language"
            className="hidden sm:inline-flex items-center gap-1.5 px-4 h-10 rounded-full border border-[var(--text-primary)]/15 hover:border-[var(--brand-gold)] hover:bg-[var(--brand-gold-light)]/30 text-sm font-medium"
          >
            <span className="text-[var(--brand-gold)]">◐</span>
            <span>{t.cta.lang}</span>
          </button>
          <button
            type="button"
            data-testid="mobile-menu-toggle"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label="Menu"
            className="md:hidden p-2 rounded-full hover:bg-[var(--bg-subtle)]"
          >
            {mobileOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[var(--bg-base)] border-t border-[var(--bg-subtle)] px-6 py-6 space-y-4"
        >
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="block text-base text-[var(--text-primary)]"
            >
              {link.label}
            </a>
          ))}
          <button
            type="button"
            data-testid="lang-toggle-mobile-btn"
            onClick={() => {
              toggle();
              setMobileOpen(false);
            }}
            className="mt-2 inline-flex items-center gap-2 px-4 h-10 rounded-full border border-[var(--text-primary)]/15 text-sm"
          >
            <span className="text-[var(--brand-gold)]">◐</span>
            {t.cta.lang}
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
